import styled, { css } from "styled-components";
import Paper from "components/Layout/Paper";
import DefaultMenuList from "@material-ui/core/MenuList";
import { COLORS } from "constants/colorScheme";
import { Popper as DefaultPopper } from "@material-ui/core";

const CARD_HEIGHT = 60;

export const Popper = styled(DefaultPopper)`
  && {
    ${({ disablePortal }) =>
      disablePortal &&
      css`
        z-index: 5;
      `};
  }
`;

export const MenuList = styled(DefaultMenuList)`
  && {
    padding: 4px 0;

    border-radius: 8px;
  }

  && .MuiListItem-root {
    display: flex;
    align-items: center;
    justify-content: space-between;

    margin: 0px;
    padding: 8px 16px;

    border-radius: 0px;
    color: ${COLORS.BLACK};

    &:hover {
      color: ${COLORS.CYAN};
      background-color: ${COLORS.CYAN_LIGHT_20};
    }
  }

  && .MuiListItem-root.Mui-selected,
  .MuiListItem-root.Mui-selected:hover {
    background-color: ${COLORS.WHITE};
    color: ${COLORS.CYAN};
    border-bottom: 2px solid ${COLORS.CYAN};
  }

  && .MuiListItemText-root {
    display: flex;
    align-items: center;
  }
`;

export const Container = styled.div`
  border-radius: 6px;
  padding: 6px 8px 7px 12px;
  background-color: ${COLORS.BACKGROUND};

  display: flex;
  align-items: center;

  margin-right: 12px;
  margin-top: 12px;
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  margin-right: 10px;

  min-height: 24px;
  min-width: 24px;

  background-image: url(${({ image }: { image: string }) => image});
  background-size: cover;
`;

export const ClearIconContainer = styled.span`
  display: flex;
  margin-left: 8px;

  cursor: pointer;
`;

export const DetailsContainer = styled(Paper)`
  display: flex;
  justify-content: center;

  height: ${CARD_HEIGHT}px;
  width: 100%;

  padding: 24px;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TitleWrapper = styled.div`
  margin-bottom: 8px;
`;

export const ControlsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 40px;
  padding: 0 8px;
`;

export const MenuIconContainer = styled.div`
  margin-left: 8px;
`;

export const MenuControlWrapper = styled.div`
  display: flex;
  align-items: center;

  margin-right: 24px;
`;

export const Menu = styled.div`
  display: flex;

  & path,
  & use {
    fill: ${COLORS.BLACK_50};
  }
`;
